// src/registered/site-admin/components/SEC_03_UserRoleAssignmentView.jsx
import React from "react";
import { GoldenSourceHelper } from "../../../app/GoldenSourceHelper"; 

export default function SEC_03_UserRoleAssignmentView(props) {
  const {
    userList, availableRoles, availableResources, userMatrix, assignedResources,
    selectedUser, roleId, resourceId, isSubmitting,
    onUserChange, onRoleChange, onResourceChange, onAssign, onBack, onReturnToDashboard
  } = props;

  return (
    <main id="main" className="page-main mt-5 pt-5" data-scroll-container>
      <div className="container">
        <div className="card shadow-sm border-0">
          <div className="card-header bg-dark text-white p-3 d-flex justify-content-between align-items-center">
            <h5 className="mb-0 fw-bold">User Security Matrix Editor</h5>
            {/* 🎯 Back to Previous Page */}
            <button className="btn btn-sm btn-outline-light" onClick={onBack}>
              &larr; Return to Menu
            </button>
          </div>

          <div className="card-body p-4">
            <div className="mb-4 p-3 bg-light border rounded">
              <label className="small fw-bold text-muted mb-2 d-block text-uppercase">1. Select Registered User</label>
              <select className="form-select form-select-lg" value={selectedUser} onChange={onUserChange}>
                <option value="">-- Choose User --</option>
                {userList.map((u, i) => (
                  <option key={i} value={GoldenSourceHelper.get(u, "SiteUserGuid")}>
                    {GoldenSourceHelper.get(u, "EmailAddress")} ({GoldenSourceHelper.get(u, "UserName")})
                  </option>
                ))}
              </select>
            </div>

            <div className="row g-4">
              <div className="col-md-4">
                <div className="p-4 border rounded bg-white shadow-sm border-primary-subtle">
                  <h6 className="fw-bold mb-3 text-primary border-bottom pb-2 text-uppercase">2. Grant Authority</h6>
                  <div className="mb-3">
                    <label className="small fw-bold">Roles</label>
                    <select className="form-select" value={roleId} onChange={onRoleChange}>
                      <option value="">-- Select Role --</option>
                      {availableRoles.map((r, i) => (
                        <option key={i} value={GoldenSourceHelper.get(r, "RoleId")}>{GoldenSourceHelper.get(r, "RoleName")}</option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-4">
                    <label className="small fw-bold">Resources</label>
                    <select className="form-select" value={resourceId} onChange={onResourceChange}>
                      <option value="">-- Global --</option>
                      {availableResources.map((res, i) => (
                        <option key={i} value={GoldenSourceHelper.get(res, "ResourceId")}>{GoldenSourceHelper.get(res, "ResourceId")}</option>
                      ))}
                    </select>
                  </div>
                  <button className="btn btn-primary w-100 fw-bold" disabled={!selectedUser || !roleId || isSubmitting} onClick={onAssign}>
                    {isSubmitting ? "Processing..." : "Assign Permission"}
                  </button>
                </div>
              </div>

              <div className="col-md-8">
                <h6 className="fw-bold text-muted text-uppercase small mb-2">Existing Roles</h6>
                <div className="table-responsive border rounded bg-white mb-4">
                  <table className="table table-hover mb-0">
                    <thead className="table-light small text-uppercase">
                      <tr><th>Roles</th><th>Resources</th><th>Granted By</th></tr>
                    </thead>
                    <tbody>
                      {userMatrix?.length > 0 ? userMatrix.map((row, i) => (
                        <tr key={i}>
                          <td><span className="badge bg-info text-dark">{GoldenSourceHelper.get(row, "RoleName")}</span></td>
                          <td>{GoldenSourceHelper.get(row, "ResourceName") || "Global"}</td>
                          <td className="small text-muted">{GoldenSourceHelper.get(row, "AssignedBy_UserName")}</td>
                        </tr>
                      )) : <tr><td colSpan="3" className="text-center py-4 text-muted small">No roles assigned.</td></tr>}
                    </tbody>
                  </table>
                </div>

                <h6 className="fw-bold text-muted text-uppercase small mb-2">Assigned Resources</h6>
                <div className="table-responsive border rounded bg-white">
                  <table className="table table-hover mb-0">
                    <thead className="table-light small text-uppercase">
                      <tr><th>Resource Type</th><th>ID</th><th>Actions</th></tr>
                    </thead>
                    <tbody>
                      {assignedResources?.length > 0 ? assignedResources.map((res, i) => (
                        <tr key={i}>
                          <td>{GoldenSourceHelper.get(res, "ResourceType")}</td>
                          <td>{GoldenSourceHelper.get(res, "ResourceId")}</td>
                          <td><button className="btn btn-sm btn-link text-danger p-0">Revoke</button></td>
                        </tr>
                      )) : <tr><td colSpan="3" className="text-center py-4 text-muted small">No resources assigned.</td></tr>}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="mt-5 border-top pt-3">
               <button className="btn btn-link text-decoration-none p-0 text-secondary small" onClick={onReturnToDashboard}>
                  &larr; Return to Registered Dashboard
               </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}